// Email service for sending form submissions via backend API

export const sendItineraryRequest = async (formData) => {
  try {
    const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
    
    const response = await fetch(`${backendUrl}/api/send-email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Failed to send email');
    }

    const result = await response.json();
    
    // Store submission locally for reference
    const submission = {
      ...formData,
      timestamp: new Date().toISOString(),
      status: 'sent',
      emailSentTo: 'contact@pomtrips.com'
    };
    
    const submissions = JSON.parse(localStorage.getItem('itineraryRequests') || '[]');
    submissions.push(submission);
    localStorage.setItem('itineraryRequests', JSON.stringify(submissions));

    console.log('✅ Email sent successfully to contact@pomtrips.com');
    
    return {
      success: true,
      message: result.message || 'Request sent successfully',
      data: submission
    };
  } catch (error) {
    console.error('❌ Failed to send email:', error);
    throw error;
  }
};

// Email template that will be used in backend
export const getEmailTemplate = (formData) => {
  return `
New Itinerary Request from POMTrips Website

Tour: ${formData.tourName || 'General Inquiry'}
Date: ${new Date().toLocaleString()}

--- Customer Details ---
Name: ${formData.name}
Email: ${formData.email}
WhatsApp/Phone: ${formData.phone}

--- Trip Details ---
Preferred Dates: ${formData.dates || 'Flexible'}
Number of Travelers: ${formData.travelers || 'Not specified'}

--- Message ---
${formData.message || 'No additional message'}

---
This request was submitted via POMTrips website.
Please respond within 24 hours.
  `;
};

// Backend API endpoint structure (for future implementation)
export const emailAPIConfig = {
  endpoint: '/api/send-email',
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  recipient: 'contact@pomtrips.com',
  subject: 'New Tour Inquiry from POMTrips Website'
};
